module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-one"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 1")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("“W")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("e’ve got a boatload of cocaine. Literally.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I looked at my friend Maggie, barely five feet tall, standing in the doorway of my office. (Technically it was her office, since I was employed by Maggie and her grandfather, Martin Bristol, at Bristol & Associates.)")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You know,” I said, “when I met you in law school, I never thought I would hear you say things like that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Maggie frowned for a second, pushing her blond, wavy hair out of her eyes. “It’s the Cortaderos.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Oh.” I leaned my elbows on the desk, interested. I’d been hearing about the Cortaderos for a long time. They were clients of Maggie and Martin’s. They were a Mexican drug cartel family (")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("allegedly ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("a cartel family, I should say), but I hadn’t been privy to the details of any cases.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She sighed and waved a hand. “They’re always getting into trouble.” This was not said without fondness. Maggie had a soft spot for most of her wayward clients.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Q, short for Quentin, stuck his bald, black head in my office, as if he’d been lingering outside the door. “Did I just hear something about a drug bust?” Q had been my assistant when we were at the white-glove firm of Baltimore & Brown. He was the office manager now at Bristol & Associates. But more important, Q loved a juicy story, especially on an otherwise slow Monday afternoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Maggie slumped into a seat across from my desk, then waved Q inside. “Have you ever seen the boats parked on the river? By Lower Wacker?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Sure,” I said. “Sam and I did a sunset cruise once. We went through the locks and out onto Lake Michigan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “They did a post-Pride cruise one year,” Q said. “Epic.” He cleared his throat. “That was before I was monogamous, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Of course,” Maggie and I echoed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I nodded at her to continue.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Right. Well, the Cortaderos own one of those boats. It was about to be taken down the Mississippi for winter, but it was seized today.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And cocaine was found on it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “A lot.” She sighed the way a mom would when discussing a teen who spent too much time in front of the computer. “Forty-five kilos.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What’s that worth?” Q asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Millions. Many.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Many millions?”")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Q said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Maggie nodded. “They usually wouldn’t have that much in one place. Strange. I don’t know what’s going on with the Cortaderos.” She looked out my window, lapsing into silence. There was nothing to see there except the blue-tinted high-rise across the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Q and I exchanged glances. Maggie had been like this lately—a little distracted, and also a little secretive, closing her mouth suddenly when she seemed about to disclose something, lapsing into long, thoughtful silences. I wondered what was going on behind the scenes at the firm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What were you saying, Mags?” I prompted her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She blinked a few times as if clearing something, coming back to us. “Oh, um…” She looked at me. “Right. Right. So, I need you on this, Iz. I have a motion to suppress that’s taking a lot of time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The other thing Maggie had been doing lately was throwing a lot of casework my way. I appreciated that, since I was a civil lawyer by training now learning the oh-so-different criminal defense world. In general, I would do anything in the world for Maggie. Now that she was my boss, I’d certainly do anything she needed for one of her clients, no matter who they were. Drug lords from Mexico, though? Interesting, sure, but actually representing them? That made me nervous.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But this was my job now, I reminded myself. I had to make a living, and although I’d been on top of the world a year ago, I was far from that now. So, I was a criminal defense lawyer. When Maggie threw work my way, I would perform. Because this was my job. One of them. For better or worse.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("I sat up straighter. “You need me on this in what way?” I asked Maggie.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Well, in the short-term, I need you on the boat. Can you go now?”")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cc58eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterOne.vue
// module id = 78
// module chunks = 0